import { useEffect } from "react";

declare global {
  interface Window {
    intercomSettings?: Record<string, unknown>;
    Intercom?: (...args: unknown[]) => void;
  }
}

const Intercom = () => {
  useEffect(() => {
    window.intercomSettings = {
      app_id: "mevw6blr",
      custom_launcher_selector: ".launch-intercom",
      // No floating launcher — chat is opened from the workspace sidebar /
      // bottom-nav "Help & chat" action (openIntercom → Intercom('show')).
      hide_default_launcher: true,
      action_color: "#ED8C22",
      background_color: "#222",
      vertical_padding: 20,
      horizontal_padding: 20,
      alignment: "right",
    };

    const ic = window.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", window.intercomSettings);
    } else {
      const i = function (...args: unknown[]) {
        (i as any).q.push(args);
      } as any;
      i.q = [] as unknown[][];
      i.c = function (args: unknown[]) {
        i.q.push(args);
      };
      window.Intercom = i;

      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://widget.intercom.io/widget/mevw6blr";
      const x = document.getElementsByTagName("script")[0];
      x?.parentNode?.insertBefore(s, x);
    }
  }, []);

  return null;
};

export default Intercom;
